import type { SessionInfo, ReferrerInfo, PreferencesInfo } from './tipos'
import { gerarUUID, getVisitorId } from './visitante'

const SESSION_ID_KEY = 'biomo_session_id'
const SESSION_START_KEY = 'biomo_session_start'
const LANDING_PAGE_KEY = 'biomo_landing_page'

/**
 * Obtém ou cria o session ID
 */
function getSessionId(): string {
  if (typeof window === 'undefined') return gerarUUID()

  try {
    let sessionId = sessionStorage.getItem(SESSION_ID_KEY)
    if (!sessionId) {
      sessionId = gerarUUID()
      sessionStorage.setItem(SESSION_ID_KEY, sessionId)
    }
    return sessionId
  } catch {
    return gerarUUID()
  }
}

/**
 * Gerencia sessão do usuário
 */
export function getSessionInfo(formStartTime?: number): SessionInfo {
  if (typeof window === 'undefined') {
    return {
      id: gerarUUID(),
      startTime: new Date().toISOString(),
      timeOnPage: 0,
      formCompletionTime: null,
    }
  }

  const sessionId = getSessionId()

  // Session start time
  let startTimeStr: string | null = null
  try {
    startTimeStr = sessionStorage.getItem(SESSION_START_KEY)
    if (!startTimeStr) {
      startTimeStr = new Date().toISOString()
      sessionStorage.setItem(SESSION_START_KEY, startTimeStr)
    }
  } catch {
    startTimeStr = new Date().toISOString()
  }

  const startTime = new Date(startTimeStr).getTime()
  const now = Date.now()

  return {
    id: sessionId,
    startTime: startTimeStr,
    timeOnPage: now - startTime,
    formCompletionTime: formStartTime ? now - formStartTime : null,
  }
}

/**
 * Coleta informações de referrer e landing page
 */
export function getReferrerInfo(): ReferrerInfo {
  if (typeof window === 'undefined') {
    return {
      url: null,
      landingPage: '',
      entryPath: '',
      visitorId: gerarUUID(),
    }
  }

  // Landing page da sessão
  let landingPage: string | null = null
  try {
    landingPage = sessionStorage.getItem(LANDING_PAGE_KEY)
    if (!landingPage) {
      landingPage = window.location.href
      sessionStorage.setItem(LANDING_PAGE_KEY, landingPage)
    }
  } catch {
    landingPage = window.location.href
  }

  return {
    url: document.referrer || null,
    landingPage,
    entryPath: new URL(landingPage).pathname,
    visitorId: getVisitorId(),
  }
}

/**
 * Coleta preferências do usuário
 */
export function getPreferencesInfo(): PreferencesInfo {
  if (typeof window === 'undefined') {
    return { language: 'pt-BR', colorScheme: 'light' }
  }

  return {
    language: navigator.language || 'pt-BR',
    colorScheme: window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',
  }
}
